export enum UserCoursesTab {
  IN_PROGRESS = 'in-progress',
  READY_TO_START = 'ready-to-start',
  COMPLETED = 'completed'
}
